import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=44777c95&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=44777c95&scoped=true&lang=css&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&lang=css&"
import style2 from "./orderDetails.vue?vue&type=style&index=2&id=44777c95&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44777c95",
  null
  
)

export default component.exports